import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import ja from 'vuetify/src/locale/ja';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196f3',
        secondary: '#3f51b5',
        accent: '#009688',
        error: '#e91e63',
        warning: '#ffc107',
        info: '#03a9f4',
        success: '#8bc34a',
        //カスタム
        colLabel: '#2d96ff',
        // colLabel: '#b3d4fc',
        colLabelText: '#FFFFFF',
        header: '#2d96ff',
        fotter: '#2d96ff',
        // menuButton: '#007fff',
        menuButton: '#3f51b5',
        menuLabel: '#aaddff',
        requiredIcon: '#ffff00',
      },
    },
  },
  lang: {
    locales: { ja },
    current: 'ja',
  },
  icons: {
    iconfont: 'mdi',
  },
});
